import { useState, useEffect } from "react";
import {getPuestoTrabajo} from "../../services/puestotrabajo";

import { getConsultArea, updatePuestoTrabajo } from "../../services/office";
import { ErrorContext } from "../../utils/context/error";
import { useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import Modal from "../modal";

function Officesetting({show, handleshow}) {
  const [areaId, setAreaId] = useState(0);
  const [consultId, setConsultId] = useState(0);
  
  const [areas, setAreas] = useState([]);
  const [consult, setConsult] = useState([]);
  const [validar, setValidar] = useState(false);
  const [habilita, setHabilita] = useState(false);
  const { setShowToast, setOpciones } = ErrorContext();
  const navigate = useNavigate()
  //--- Boton Aceptar
  const handleLogin = async () => 
    {
      setHabilita(true);
      setValidar(true);
      setShowToast(false);
      if (areaId > 0 && consultId >0) 
        {
           const Data = 
           {
              areaId,
              consultId,
           };
           const response = await updatePuestoTrabajo(Data);
           if (response) 
            {
               if (response.status === 200) 
                {
                   handleshow(false);
                   setValidar(false);
                   // refresh
                   navigate(0)
                } 
               else 
                {
                   const Mensaje = response.message;
                   const opc = { type: "Danger", message: Mensaje, active: true };
                   setOpciones(opc);
                   setShowToast(true);
                }
            }
            else 
              {
                const Mensaje = response.message;
                const opc = { type: "Danger", message: Mensaje, active: true };
                setOpciones(opc);
                setShowToast(true);
             }
        }
      setHabilita(false);
   };
  
   //-- Botón Cancelar
  const handleCancel = async () => 
    {
      handleshow(false);
    };
  //---- 
  const fillPuestoTrab = async () => 
    {
       const response = await getPuestoTrabajo();
       if (response) 
        {
           if (response.status === 200) 
            {
               setAreas(response.data.area);
               setAreaId(response.data.data[0]?.AreaId ?? 0);
               setConsultId(response.data.data[0]?.ConsultId ?? 0);
            } 
           else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           }
        }
    };

  //----  
  const handlearea =(area) =>{
    setConsultId(0);
    setAreaId(area);
  } 

  //----- Consultorios
  const fillConsultorio =  async () => 
    {
      const response = await getConsultArea(areaId);
      if (response.status === 200) 
        setConsult(response.data.data);
      else 
        {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
        }
    };
  
  //-----
  useEffect(() => 
    {
      fillPuestoTrab();
    }, []);

  //---
  useEffect(() => 
    {
       if (areaId > 0 ) 
         fillConsultorio(areaId);
    }, [areaId]);

  return (
    <>
     <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Puesto de Trabajo'}>
      <div className="flex w-full h-full">
         <form noValidate>
            <div className="w-full">
               <label>Area</label>
               <select id="area" name="area" value={areaId||0} onChange={(e) => handlearea(Number(e.target.value))} label="Area" 
                  className={`${validar && areaId === 0 ? `border-red-500 focus:border-red-500 focus:red-500`: ""}`}>
                 <option value={0} disabled>
                    Seleccionar una Area...
                  </option>
                  {areas.map((item) => {
                     return (
                       <option key={item.AreaId} value={item.AreaId}>
                         {item.NombreArea}
                       </option>
                      );
                  })}
               </select>
               {validar && areaId === 0 ? (
                <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                  * Campo Obligatorio.
                </p>
              ) : (
                ""
              )}
            </div>

            <div className="mt-4">
               <label>Consultorio</label>
               <select id="modulo" name="modulo" value={consultId|| 0} onChange={(e) => setConsultId(Number(e.target.value))} label="Modulo"
                 className={`${validar && consultId === 0 ? `validar`: ""}`}>
               <option value={0} disabled>
                    Seleccionar un Consultorio...
                  </option>
                  {consult.map((item) => {
                     return (
                       <option key={item.ConsultId} value={item.ConsultId}>
                         {item.NombConsult}
                       </option>
                      );
                  })}
               </select>
               {validar && consultId === 0 ? (
                <p className={`text-red-500 text-[0.6rem] font-medium italic`}>
                  * Campo Obligatorio.
                </p>
              ) : (
                ""
              )}
             </div>  
               <div className="flex w-full gap-4 mt-6 justify-end">
                 <button name="Aceptar" className="btnprimary" onClick={handleLogin} disabled={habilita} type="button">Aceptar</button>
                 <button name="Cancelar" className="" onClick={handleCancel} disabled={habilita} type="button">Cancelar</button>
               </div>
            
         </form>
         </div>
     </Modal>
    
    </>
  );
}
Officesetting.propTypes = {
  show: PropTypes.bool.isRequired,
  handleshow: PropTypes.func.isRequired,
  
};

export default Officesetting;
